import * as effects from 'redux-saga/effects';

import { chatActions } from '../actions';
// eslint-disable-next-line prettier/prettier
import {
  fetchMessages,
  loadMoreMessages,
  loadPrevMessages,
  fetchChannels,
  createChannel,
  sendData,
  debounceChat,
  replaceData,
  checkTokens,
  deleteChannel,
} from './workers';

// IMPORTS
function* watchFetchMessages() {
  yield effects.takeEvery(chatActions.fetchMessages.type, fetchMessages);
}
function* watchLoadMoreMessages() {
  yield effects.takeEvery(chatActions.loadMoreMessages.type, loadMoreMessages);
}
function* watchLoadPrevMessages() {
  yield effects.takeEvery(chatActions.loadPrevMessages.type, loadPrevMessages);
}

function* watchFetchChannels() {
  yield effects.takeEvery(chatActions.fetchChannels.type, fetchChannels);
}
function* watchCreateChannel() {
  yield effects.takeEvery(chatActions.createChannel.type, createChannel);
}
function* watchSendData() {
  yield effects.takeEvery(chatActions.sendData.type, sendData);
}
function* watchReplaceData() {
  yield effects.takeEvery(chatActions.replaceData.type, replaceData);
}
function* watchDebounceChat() {
  yield effects.takeLatest(chatActions.debounceChat.type, debounceChat);
}
function* watchCheckTokens() {
  yield effects.takeLatest(chatActions.checkTokens.type, checkTokens);
}
function* watchDeleteChannel() {
  yield effects.takeLatest(chatActions.deleteChannel.type, deleteChannel);
}
// WATCHERS
export function* watchChat() {
  // eslint-disable-next-line prettier/prettier
  yield effects.all([
    effects.call(watchFetchMessages),
    effects.call(watchLoadMoreMessages),
    effects.call(watchLoadPrevMessages),
    effects.call(watchFetchChannels),
    effects.call(watchCreateChannel),
    effects.call(watchDebounceChat),
    effects.call(watchSendData),
    effects.call(watchReplaceData),
    effects.call(watchCheckTokens),
    effects.call(watchDeleteChannel),
    // INJECT
  ]);
}
